import { AnimalGender } from 'gql/types';

export const animalGender = Object.values(AnimalGender).map((value) => {
  return {
    value,
    label: value,
  };
});
